import {
  clearDashboardQueryCache,
  startDashboardQueryPersistence,
} from "@dashboard/lib/dashboard-query-persistence"
import { DASHBOARD_SESSION_EXPIRED_EVENT } from "@playbrain/auth/dashboard"
import { QueryClient } from "@tanstack/react-query"
import { createRouter } from "@tanstack/react-router"
import { setupRouterSsrQueryIntegration } from "@tanstack/react-router-ssr-query"
import { routeTree } from "../../routeTree.gen"

export function getRouter() {
  const queryClient = new QueryClient()

  const router = createRouter({
    routeTree,
    context: {
      queryClient,
    },
    scrollRestoration: true,
    defaultPreload: "intent",
  })

  setupRouterSsrQueryIntegration({
    router,
    queryClient,
  })

  if (typeof window !== "undefined") {
    window.__TSR_ROUTER__ = router
    startDashboardQueryPersistence(queryClient)
    /*
     * Sign-out clears this at the click, but a session that simply ran out
     * never passes through that path — so the expiry event has to clear it too,
     * or the next person to sign in on this machine inherits the last one's
     * section titles.
     */
    window.addEventListener(DASHBOARD_SESSION_EXPIRED_EVENT, clearDashboardQueryCache)
  }

  return router
}

declare module "@tanstack/react-router" {
  interface Register {
    router: ReturnType<typeof getRouter>
  }
}
